
<mat-card *ngIf="entityId === 0" class="portal-page-heading mb-2">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-4">

      <h1 class="portal-page-title">Manage In Home Care Complaints</h1>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col" *ngIf="complaint.id == 0" [@slideRight]>
  <div class="flex flex-row justify-end gap-2 mb-2 portal-actions">
    <button type="button" mat-stroked-button color="primary"
            [disabled]="creating" (click)="addComplaint()">Add Complaint</button>
    <button type="button" mat-stroked-button color="primary"
            [attr.aria-pressed]="showClosedComplaints" (click)="toggleClosedComplaints()">
      {{ showClosedComplaints ? 'Hide Closed Complaints' : 'Show Closed Complaints' }}
    </button>
  </div>
  <mat-table [dataSource]="complaintSource" matSort #complaintSort="matSort" aria-describedby="complaints" class="mat-elevation-z8">
    <!-- Complaint ID Column -->
    <ng-container matColumnDef="complaintId">
      <mat-header-cell *matHeaderCellDef> Complaint ID </mat-header-cell>
      <mat-cell *matCellDef="let complaint">
        <div class="flex flex-row gap-4 items-center portal-actions">
          {{complaint.complaintId}}
          <button mat-icon-button (click)="sharedService.copyToClipboard(complaint.complaintId)" color="primary"
            matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="entityGuid">
      <mat-header-cell *matHeaderCellDef> Entity ID </mat-header-cell>
      <mat-cell *matCellDef="let complaint">
        <div class="flex flex-row gap-4 items-center portal-actions">
          {{complaint.entityGuid}}
          <button mat-icon-button (click)="sharedService.copyToClipboard(complaint.entityGuid)" color="primary"
            matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Entity Column -->
    <ng-container matColumnDef="entity">
      <mat-header-cell *matHeaderCellDef> Entity </mat-header-cell>
      <mat-cell (click)="selectComplaint(complaint)" *matCellDef="let complaint" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectComplaint(complaint))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectComplaint(complaint))"> {{complaint.entity}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="unlicensedAgency">
      <mat-header-cell *matHeaderCellDef> Unlicensed Agency </mat-header-cell>
      <mat-cell (click)="selectComplaint(complaint)" *matCellDef="let complaint" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectComplaint(complaint))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectComplaint(complaint))"> {{complaint.unlicensedAgency? 'Yes' : 'No'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="summary">
      <mat-header-cell *matHeaderCellDef> Summary </mat-header-cell>
      <mat-cell (click)="selectComplaint(complaint)" *matCellDef="let complaint" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectComplaint(complaint))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectComplaint(complaint))">
        <div class="flex flex-col py-2">
          <span *ngFor="let summaryItem of getSummaryArray(complaint)">{{ summaryItem }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="closed">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
      <mat-cell *matCellDef="let complaint">{{ complaint.closed ? 'Closed' : 'Open' }}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="complaintColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: complaintColumns;"></mat-row>
  </mat-table>
</div>

<div class="flex flex-col" *ngIf="complaint.id != 0" [@slideRight]>
  <div class="flex flex-row ml-auto portal-actions">
    <button mat-button color="accent" (click)="toggleEdit()"
        matTooltip="Edit Complaint" matTooltipShowDelay=800 aria-label="Edit Complaint">
      {{ editing ? 'View' : 'Edit' }}
    </button>
    <button mat-button color="primary" (click)="updateComplaint()"
        matTooltip="Save Complaint" matTooltipShowDelay=800 aria-label="Save Complaint">
      Save
    </button>
    <button type="button" mat-button color="warn" (click)="closeComplaint()">Close</button>
  </div>
  <div class="w-full mx-auto p-4" *ngIf="!editing">
    <div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">
      <!-- Complainant Info -->
      <div class="flex flex-col w-full md:w-1/2">
        <h3 class="text-2xl font-semibold pb-2">Complainant</h3>
        <mat-card>
          <mat-card-content>
            <div class="space-y-2 text-lg">
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Name: </span>
                <span>{{ complaint?.firstName }} {{ complaint?.middleName }} {{ complaint?.lastName }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Phone: </span>
                <span>{{ complaint?.phone }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Email: </span>
                <span>{{ complaint?.email }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Address: </span>
                <span>{{ complaint?.complainantAddress }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Facility/Agency Employee: </span>
                <span>{{ complaint?.employeeStatus }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Never an employee: </span>
                <span>{{ complaint?.neverAnEmployee ? 'Yes' : 'No' }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/3">Works for APS/State agency: </span>
                <span>{{ complaint?.workForAPS === true ? 'Yes' : (complaint?.workForAPS === false ? 'No' : '') }}</span>
              </div>
              <div class="flex flex-col md:flex-row" *ngIf="complaint?.workForAPS">
                <span class="font-medium md:w-1/3">Agency: </span>
                <span>{{ complaint?.apsAgency }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Agency & Incident Info -->
      <div class="flex flex-col w-full md:w-1/2">
        <h3 class="text-2xl font-semibold pb-2">Agency Information</h3>
        <mat-card>
          <mat-card-content>
            <div class="space-y-2 text-lg">
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/2">Agency: </span>
                <span>{{ complaint?.entity }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/2">Agency is Unlicensed: </span>
                <span>{{ complaint?.unlicensedAgency ? 'Yes' : 'No' }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/2">Incident dates/times: </span>
                <span>{{ complaint?.incidentDates }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/2">Others with knowledge: </span>
                <span>{{ complaint?.othersWithKnowledge }}</span>
              </div>
              <div class="flex flex-col md:flex-row">
                <span class="font-medium md:w-1/2">Reported to agency: </span>
                <p class="mt-1">{{ complaint?.complaintSubmittedAgency }}</p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Affected People Table -->
    <div class="flex flex-col w-full py-4">
      <h3 class="text-2xl font-semibold pb-2">Affected People</h3>
      <mat-table [dataSource]="complaint.affectedPeople" multiTemplateDataRows class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let person">
            {{ person?.firstName }} {{ person?.middleName }} {{ person?.lastName }}
          </mat-cell>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
          <mat-cell *matCellDef="let person"> {{ person?.phone | mask: '(000) 000-0000' }} </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
          <mat-cell *matCellDef="let person"> {{ person?.email }} </mat-cell>
        </ng-container>

        <!-- Relationship Column -->
        <ng-container matColumnDef="relationship">
          <mat-header-cell *matHeaderCellDef> Relationship </mat-header-cell>
          <mat-cell *matCellDef="let person">
            {{ person?.relationship === 'Other' ? person?.relationshipOther : person?.relationship }}
          </mat-cell>
        </ng-container>

        <!-- Expand Icon Column -->
        <ng-container matColumnDef="canContact">
          <mat-header-cell *matHeaderCellDef> Can Contact </mat-header-cell>
          <mat-cell *matCellDef="let person"> {{ person?.canContact === true ? 'Yes' : (person?.canContact === false ? 'No' : 'N/A') }} </mat-cell>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let person" [attr.colspan]="affectedPeopleColumns.length">
              <ng-container [ngTemplateOutlet]="personDetails"
                            [ngTemplateOutletContext]="{person: person}">
              </ng-container>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="affectedPeopleColumns"></mat-header-row>
        <mat-row *matRowDef="let person; columns: affectedPeopleColumns;"
                 class="person-row"
                 [class.expanded-row]="expandedPerson === person"
                 (click)="expandedPerson = expandedPerson === person ? null : person" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                 class="detail-row"
                 [style.display]="expandedPerson ? '' : 'none'"></mat-row>
      </mat-table>
    </div>

    <div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">
      <!-- Description & Summary -->
      <div class="flex flex-col w-full md:w-1/2">
        <h3 class="text-2xl font-semibold pb-2">Description & Summary</h3>
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col gap-2">
              <span class="font-semibold text-xl">Description: </span>
              <p class="mt-1">{{ complaint?.description }}</p>
              <div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">
                <div class="flex flex-col md:w-1/2">
                  <span class="font-semibold text-xl">Summary: </span>
                  <div class="flex flex-col">
                    <span *ngFor="let summaryItem of getSummaryArray(complaint)">{{ summaryItem }}</span>
                  </div>
                </div>
              <div class="flex flex-col md:w-1/2" *ngIf="complaint.summaryOther">
                <span class="font-semibold text-xl">Summary Details: </span>
                <span>{{ complaint?.summaryOther }}</span>
              </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="flex flex-col w-full md:w-1/2">
        <!-- Additional details full width -->
        <h3 class="text-2xl font-semibold">Other Reports & Actions</h3>
        <mat-card class="mt-2">
          <mat-card-content>
            <div class="text-lg">
              <div>
                <span class="font-semibold text-xl">Reported to other agency:</span>
                <p class="mt-1">{{ complaint?.complaintSubmittedOther }}</p>
              </div>
              <div class="mt-4">
                <span class="font-semibold text-xl">Reported to police:</span>
                <p class="mt-1">{{ complaint?.complaintSubmittedPolice }}</p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Editable Complaint Form -->
  <form [formGroup]="complaintForm" class="w-full mx-auto p-4" *ngIf="editing" [@slideRight]>
    <div class="flex flex-col gap-2">
      <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid">
        <!-- Complainant Section -->
        <div class="w-full md:w-1/2">
          <h3 class="text-2xl font-semibold pb-2">Complainant</h3>
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col">
                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName">
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>Middle Name</mat-label>
                    <input matInput formControlName="middleName">
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName">
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone" mask="000-000-0000">
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email">
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/3" appearance="fill">
                    <mat-label>Complainant Address</mat-label>
                    <input matInput formControlName="complainantAddress" />
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <mat-form-field class="w-full md:w-1/2" appearance="fill">
                    <mat-label>Employee Status</mat-label>
                    <input matInput formControlName="employeeStatus">
                  </mat-form-field>

                  <div class="flex flex-col w-full md:w-1/2 pb-4">
                    <div class="w-full">
                      <mat-checkbox formControlName="neverAnEmployee">
                        Never an Employee
                      </mat-checkbox>
                    </div>

                    <div class="w-full">
                      <mat-checkbox formControlName="workForAPS">
                        Works for APS/State Agency
                      </mat-checkbox>
                    </div>
                    <mat-form-field class="w-full mt-4" appearance="fill"
                                    *ngIf="complaintForm.controls.workForAPS.value">
                      <mat-label>APS/State Agency</mat-label>
                      <input matInput formControlName="apsAgency">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Agency Section -->
        <div class="w-full md:w-1/2">
          <h3 class="text-2xl font-semibold pb-2">Agency Information</h3>
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col">
                <mat-form-field class="w-full">
                  <mat-label>Agency</mat-label>
                  <mat-select formControlName="entity" (selectionChange)="selectAgency($event.value)">
                    <mat-option *ngFor="let agency of ihcAgencies" [value]=agency.agencyName>{{agency.agencyName}} {{agency.city}}</mat-option>
                    <mat-option value="Other">-- Other --</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full" *ngIf="adding">
                  <mat-label>Entity ID</mat-label>
                  <input matInput formControlName="entityGuid" [readonly]="entityId > 0"
                         (change)="setComplaintEntityId()">
                </mat-form-field>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid" *ngIf="complaintForm.get('entity')?.value === 'Other'">
                  <mat-form-field class="w-full">
                    <mat-label>Other Agency</mat-label>
                    <input matInput formControlName="otherEntity">
                  </mat-form-field>

                  <div class="w-full">
                    <mat-checkbox formControlName="unlicensedAgency">
                      Agency is Unlicensed
                    </mat-checkbox>
                  </div>
                </div>

                <mat-form-field class="w-full">
                  <mat-label>Others with Knowledge</mat-label>
                  <input matInput formControlName="othersWithKnowledge">
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>Incident Dates/Times</mat-label>
                  <textarea matInput formControlName="incidentDates" rows="2"></textarea>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>Reported to Agency</mat-label>
                  <textarea matInput formControlName="complaintSubmittedAgency" rows="2"></textarea>
                </mat-form-field>

              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Affected People Editable Table -->
      <div class="flex flex-col w-full py-4">
        <div class="flex flex-row items-center pb-2 portal-actions">
          <h3 class="text-2xl font-semibold pb-2 flex-grow">Affected People</h3>
          <button mat-raised-button color="primary" class="ml-auto" (click)="addAffectedPerson()"
                  matTooltip="Add Affected Person" matTooltipShowDelay="800" aria-label="Add Affected Person">
            Add A Person
          </button>
        </div>
        <mat-table [dataSource]="affectedPeopleSource" multiTemplateDataRows class="mat-elevation-z8">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
            <mat-cell *matCellDef="let person" (click)="expandedPerson = expandedPerson === person ? null : person" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)">
              {{ person?.firstName }} {{ person?.middleName }} {{ person?.lastName }}
            </mat-cell>
          </ng-container>

          <!-- Phone Column -->
          <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
            <mat-cell *matCellDef="let person" (click)="expandedPerson = expandedPerson === person ? null : person" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)"> {{ person?.phone | mask: '(000) 000-0000' }} </mat-cell>
          </ng-container>

          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
            <mat-cell *matCellDef="let person" (click)="expandedPerson = expandedPerson === person ? null : person" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)"> {{ person?.email }} </mat-cell>
          </ng-container>

          <!-- Relationship Column -->
          <ng-container matColumnDef="relationship">
            <mat-header-cell *matHeaderCellDef> Relationship </mat-header-cell>
            <mat-cell *matCellDef="let person" (click)="expandedPerson = expandedPerson === person ? null : person" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (expandedPerson = expandedPerson === person ? null : person)">
              {{ person?.relationship === 'Other' ? person?.relationshipOther : person?.relationship }}
            </mat-cell>
          </ng-container>

          <!-- Expand Icon Column -->
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let person">
              <div class="flex flex-row gap-4 portal-actions">
                <button mat-icon-button color="primary" (click)="editAffectedPerson(person)"
                        matTooltip="Edit Affected Person" matTooltipShowDelay="800" aria-label="Edit Affected Person">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteAffectedPerson(person)"
                        matTooltip="Delete Affected Person" matTooltipShowDelay="800" aria-label="Delete Affected Person">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Expanded Content Column -->
          <ng-container matColumnDef="expandedDetail">
              <mat-cell *matCellDef="let person" [attr.colspan]="affectedPeopleEditColumns.length">
                <ng-container [ngTemplateOutlet]="personDetails"
                              [ngTemplateOutletContext]="{person: person}">
                </ng-container>
              </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="affectedPeopleEditColumns"></mat-header-row>
          <mat-row *matRowDef="let person; columns: affectedPeopleEditColumns;"
                  class="person-row"
                  [class.expanded-row]="expandedPerson === person">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                  class="detail-row"
                  [style.display]="expandedPerson ? '' : 'none'"></mat-row>
        </mat-table>
      </div>

      <div class="flex flex-col md:flex-row md:gap-2 portal-section-grid">
        <!-- Description Section -->
        <div class="w-full md:w-1/2">
          <h3 class="text-2xl font-semibold pb-2">Description & Summary</h3>
          <mat-card>
            <mat-card-content>
              <div>
                <mat-form-field class="w-full md:col-span-2 lg:col-span-3" appearance="fill">
                  <mat-label>Description of Complaint</mat-label>
                  <textarea matInput formControlName="description" rows="2"></textarea>
                </mat-form-field>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <mat-form-field class="w-full md:w-1/2">
                    <mat-label>Summary</mat-label>
                    <mat-select formControlName="summary" multiple (selectionChange)="onSummaryChange($event.value)">
                      <mat-option value="Client Abuse">Client Abuse (including financial)</mat-option>
                      <mat-option value="Client Neglect">Client Neglect</mat-option>
                      <mat-option value="Client Injury">Client Injury</mat-option>
                      <mat-option value="Client Death">Client Death</mat-option>
                      <mat-option value="Services are not being provided">Services are not being provided</mat-option>
                      <mat-option value="Quality of care">Quality of care</mat-option>
                      <mat-option value="Caregivers are not staffing scheduled shifts">Caregivers are not staffing scheduled shifts</mat-option>
                      <mat-option value="Caregivers are inadequately trained">Caregivers are inadequately trained</mat-option>
                      <mat-option value="Caregiver has an inadequate background check">Caregiver has an inadequate background check</mat-option>
                      <mat-option value="Termination rights">Termination rights</mat-option>
                      <mat-option value="False billing">False billing</mat-option>
                      <mat-option value="Falsification of records">Falsification of records</mat-option>
                      <mat-option value="Complaints to the agency were unaddressed">Complaints to the agency were unaddressed</mat-option>
                      <mat-option value="Unlicensed Business/Agency providing IHC services">Unlicensed Business/Agency providing IHC services</mat-option>
                      <mat-option value="Infection control">Infection control</mat-option>
                      <mat-option value="Nursing services">Nursing services</mat-option>
                      <mat-option value="Medication services">Medication services</mat-option>
                      <mat-option value="Other">Other</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/2" appearance="fill" *ngIf="isSummaryOther()">
                    <mat-label>Summary Details (Other)</mat-label>
                    <input matInput formControlName="summaryOther"/>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Reports Section -->
        <div class="w-full md:w-1/2">
          <h3 class="text-2xl font-semibold pb-2">Other Reports</h3>
          <mat-card>
            <mat-card-content>
              <div class="flex flex-col">
                <mat-form-field class="w-full md:col-span-2 lg:col-span-3" appearance="fill">
                  <mat-label>Reported to Other Agency</mat-label>
                  <textarea matInput formControlName="complaintSubmittedOther" rows="2"></textarea>
                </mat-form-field>

                <mat-form-field class="w-full md:col-span-2 lg:col-span-3" appearance="fill">
                  <mat-label>Reported to Police</mat-label>
                  <textarea matInput formControlName="complaintSubmittedPolice" rows="2"></textarea>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </form>

  <div class="flex flex-col md:flex-row md:gap-2 p-4 portal-section-grid">
    <!-- Compliance Actions -->
    <div class="flex flex-col w-full md:w-1/2">
      <h3 class="text-2xl font-semibold pb-2">Compliance Actions</h3>
      <mat-card>
        <mat-card-content>
          <div class="flex flex-col">
            <form [formGroup]="complaintForm">
              <div class="flex flex-col">
                <!-- Requires Investigation -->
                <div class="flex flex-row items-center gap-4 mt-4">
                  <div class="flex flex-col gap-2">
                    <span id="requires-investigation-label">Requires Investigation</span>
                    <mat-radio-group formControlName="requiresInvestigation"
                                     aria-labelledby="requires-investigation-label"
                                     class="flex flex-row gap-4">
                      <mat-radio-button [value]="true">Yes</mat-radio-button>
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <mat-form-field class="w-1/2 ml-auto" subscriptSizing="dynamic">
                    <mat-label>Priority</mat-label>
                    <mat-select formControlName="priority">
                      <mat-option value="low">Low</mat-option>
                      <mat-option value="medium">Medium</mat-option>
                      <mat-option value="high">High</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Reason for Investigation -->
                <mat-form-field class="w-full mt-4" *ngIf="complaintForm.controls.requiresInvestigation.value === true">
                  <mat-label>Reason for Investigation</mat-label>
                  <textarea matInput formControlName="reasonForInvestigation" rows="3"></textarea>
                </mat-form-field>

                <mat-form-field class="w-full mt-4" *ngIf="complaintForm.controls.requiresInvestigation.value === false">
                  <mat-label>Reason Investigation Is Not Required</mat-label>
                  <mat-select formControlName="investigationNarrative">
                    <mat-option value="No Jurisdiction">No Jurisdiction</mat-option>
                    <mat-option value="Referral">Referral</mat-option>
                    <mat-option value="No Action Needed">No Action Needed</mat-option>
                    <mat-option value="Other">Other</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <!-- Triage Date -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Triage Date</mat-label>
                    <input matInput [matDatepicker]="triageDatePicker" formControlName="triageDate">
                    <mat-datepicker-toggle matSuffix [for]="triageDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #triageDatePicker></mat-datepicker>
                  </mat-form-field>

                  <!-- Triage Decision -->
                  <mat-form-field class="w-full md:w-2/3 mt-4">
                    <mat-label>Triage Decision</mat-label>
                    <input matInput formControlName="triageDecision">
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <!-- Investigation Entrance Date -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Investigation Entrance Date</mat-label>
                    <input matInput [matDatepicker]="investigationEntranceDatePicker" formControlName="investigationEntranceDate">
                    <mat-datepicker-toggle matSuffix [for]="investigationEntranceDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #investigationEntranceDatePicker></mat-datepicker>
                  </mat-form-field>

                  <!-- Investigation Exit Date -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Investigation Exit Date</mat-label>
                    <input matInput [matDatepicker]="investigationExitDatePicker" formControlName="investigationExitDate">
                    <mat-datepicker-toggle matSuffix [for]="investigationExitDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #investigationExitDatePicker></mat-datepicker>
                  </mat-form-field>

                  <!-- Investigation End Date -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Investigation End Date</mat-label>
                    <input matInput [matDatepicker]="investigationEndDatePicker" formControlName="investigationEndDate">
                    <mat-datepicker-toggle matSuffix [for]="investigationEndDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #investigationEndDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Days Until Investigation Is Due</mat-label>
                    <input matInput type="number" min="0" step="1"
                           formControlName="investigationDueInDays"
                           (input)="updateInvestigationDueDate()">
                    <mat-hint>Calendar days from today</mat-hint>
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Investigation Due Date</mat-label>
                    <input matInput [matDatepicker]="investigationDueDatePicker" formControlName="investigationDueDate">
                    <mat-datepicker-toggle matSuffix [for]="investigationDueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #investigationDueDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
                  <!-- Date Report Sent -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Date Report Sent</mat-label>
                    <input matInput [matDatepicker]="dateReportSentPicker" formControlName="dateReportSent">
                    <mat-datepicker-toggle matSuffix [for]="dateReportSentPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateReportSentPicker></mat-datepicker>
                  </mat-form-field>

                  <!-- Plan of Correction Due -->
                  <mat-form-field class="w-full md:w-1/3 mt-4">
                    <mat-label>Plan of Correction Due</mat-label>
                    <input matInput [matDatepicker]="planOfCorrectionDuePicker" formControlName="planOfCorrectionDue">
                    <mat-datepicker-toggle matSuffix [for]="planOfCorrectionDuePicker"></mat-datepicker-toggle>
                    <mat-datepicker #planOfCorrectionDuePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </form>
            <div class="flex flex-row justify-end mt-4 portal-actions">
              <button type="button" mat-stroked-button color="warn"
                      [disabled]="complaint.closed" (click)="updateComplaint(true)">
                {{ complaint.closed ? 'Complaint Closed' : 'Close Complaint' }}
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="flex flex-col gap-2 w-full md:w-1/2">
      <app-allegation [complaintId]="complaint.id"></app-allegation>

      <!-- Notes -->
      <notes class="pt-4"
            [entityId]="complaint.id"
            [entityType]="sharedService.complaint">
      </notes>

      <span class="font-semibold">Documents</span>
      <document [entityId]="complaint.id"
          [entityType]="sharedService.complaint"
          [types]="['Other']"
          [editable]="editing">
      </document>

    </div>
  </div>

  <div class="flex flex-row portal-actions">
    <button mat-button color="primary" (click)="updateComplaint()"
            matTooltip="Save Complaint" matTooltipShowDelay=800 aria-label="Save Complaint">Save</button>
    <button type="button" mat-button color="warn" (click)="closeComplaint()">Close</button>
  </div>

</div>

<ng-template #personDetails let-person="person">
  <div class="person-detail w-full" [@detailExpand]="person == expandedPerson ? 'expanded' : 'collapsed'">
    <div class="person-detail-content p-6">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">

          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Full Name</span>
            <span class="text-lg">{{ person?.firstName }} {{ person?.middleName }} {{ person?.lastName }}</span>
          </div>

          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Email</span>
            <span class="text-lg">{{ person?.email }}</span>
          </div>

          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Address</span>
            <span class="text-lg">{{ person?.address }}</span>
          </div>

          <div class="flex flex-col">
            <span class="font-semibold">Phone</span>
            <span class="text-lg">{{ person?.phone | mask: '(000) 000-0000' }}</span>
          </div>

          <div class="flex flex-col">
            <span class="font-semibold">Date of Birth</span>
            <span class="text-lg">{{ person?.dob | date: 'MM/dd/yyyy' }}</span>
          </div>

          <div class="flex flex-col">
            <span class="font-semibold">Gender</span>
            <span class="text-lg">{{ person?.gender }}</span>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Client Responded</span>
            <span class="text-lg">{{ person?.clientResponded ? 'Yes' : 'No' }}</span>
          </div>
          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Relationship</span>
            <span class="text-lg">{{ person?.relationship }}</span>
          </div>
          <div class="flex flex-col w-1/5" *ngIf="person?.relationship === 'Other'">
            <span class="font-semibold">Relationship Other</span>
            <span class="text-lg">{{ person?.relationshipOther }}</span>
          </div>
          <div class="flex flex-col">
            <span class="font-semibold">Can Contact</span>
            <span class="text-lg">{{ person?.canContact === true ? 'Yes' : (person?.canContact === false ? 'No' : 'N/A') }}</span>
          </div>
          <div class="flex flex-col" *ngIf="person?.whyNoContact">
            <span class="font-semibold">Why No Contact</span>
            <span class="text-lg">{{ person?.whyNoContact }}</span>
          </div>
          <div class="flex flex-col" *ngIf="person?.otherContactReason">
            <span class="font-semibold">Other Contact Reason</span>
            <span class="text-lg">{{ person?.otherContactReason }}</span>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Incident Location</span>
            <span class="text-lg">{{ person?.incidentLocation }}</span>
          </div>
          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Date Admitted</span>
            <span class="text-lg">{{ person?.dateAdmitted | date: 'MM/dd/yyyy' }}</span>
          </div>
          <div class="flex flex-col w-1/5">
            <span class="font-semibold">Current Patient</span>
            <span class="text-lg">{{ person?.currentPatient === true ? 'Yes' : (person?.currentPatient === false ? 'No' : 'N/A') }}</span>
          </div>
          <div class="flex flex-col">
            <span class="font-semibold">Date Discharged</span>
            <span class="text-lg">{{ person?.dateDischarged | date: 'MM/dd/yyyy' }}</span>
          </div>
        </div>

        <div class="flex flex-col">
          <span class="font-semibold">Services Received</span>
          <span class="text-lg">{{ person?.servicesReceived }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-semibold">Client Schedule</span>
          <span class="text-lg">{{ person?.clientSchedule }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-semibold">Client Narrative</span>
          <p class="text-lg whitespace-pre-wrap">{{ person?.clientNarrative }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
